// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_93444fe79c--wrapper--C1mw7","wrapper_redesign":"_93444fe79c--wrapper_redesign--dDzY3"};